<template>
    <span class="statistics-global-filter__filter">
        <select name="consultant" id="consultant"
                class="form-control select2-ajax"
                data-allow-clear="false"
                :data-url="config.url"
                data-text_field="text"
                data-id_field="statistic_route"
                data-dropdown-css-class ="select2-dropdown--big"
                ref="filter"
        >
            <option :value="option.value" v-for="option in config.options">{{ option.label }}</option>
        </select>
    </span>
</template>

<script>
    export default {
        props: ['config'],
        created() {
            this.$nextTick(() => {
                $(this.$refs.filter).on('change', function () {
                    window.location.href = $(this).val();
                });
            });
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/statistics/partials/global_filters/consultant.vue